import React, { useEffect, useState } from "react";
import { getPrivacyPolicy, getSeoByUrl } from "../api/api";
import { Helmet } from "react-helmet-async";

const TermsCondition = () => {
  const [policy, setPolicy] = useState("");
  const [seoData, setSeoData] = useState({});

  // Fetch policy content
  useEffect(() => {
    const fetchPolicy = async () => {
      const response = await getPrivacyPolicy();
      if (response.status && response.data && response.data.terms_condition) {
        setPolicy(response.data.terms_condition);
      } else {
        setPolicy("<p>Failed to load terms and conditions.</p>");
      }
    };
    fetchPolicy();
  }, []);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("terms-conditions");
        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };
    fetchSeoData();
  }, []);

  return (
    <div className="custom-padding xl-screen-padding pt-80 pb-80 font-lato">
      <Helmet>
        <title>
          {seoData.metaTitle || "Terms & Conditions | Nutrillion"}
        </title>

        <meta
          name="description"
          content={seoData.metaDescription || "Read Nutrillion's terms and conditions for using our services"}
        />

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={seoData.canonicalUrl || "https://nutrillion.one/terms-conditions"}
        />
      </Helmet>
      <div className="policy-content" dangerouslySetInnerHTML={{ __html: policy }} />
    </div>
  );
};

export default TermsCondition;